import { Avatar } from '~/components/Avatar';
import { cn } from '~/lib/cn';

interface UserInfoProps extends React.HTMLAttributes<HTMLDivElement> {
  fullName: string;
}

export function UserInfo({ fullName, className, ...props }: UserInfoProps) {
  return (
    <div className={cn('flex items-center', className)} {...props}>
      <Avatar name={fullName} className="mr-sm" variant="base" size="sm" />
      <span className="max-w-[calc(100%-2.25rem)] break-words text-default">
        {fullName}
      </span>
    </div>
  );
}

UserInfo.displayName = 'UserInfo';
